export default __webpack_public_path__ + "assets/helpilepsy_icon_web.png";